/* DARK ANGEL — theme behaviour. Progressive enhancement only. */
(function () {
  'use strict';

  /* ---------- Mobile menu drawer ---------- */
  var drawer = document.getElementById('MenuDrawer');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    var trigger = document.querySelector('[data-drawer-open]');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { setDrawer(true); }
    if (e.target.closest('[data-drawer-close]')) { setDrawer(false); }
  });

  /* ---------- Search overlay ---------- */
  var overlay = document.getElementById('SearchOverlay');
  function setSearch(open) {
    if (!overlay) return;
    overlay.classList.toggle('is-open', open);
    overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      var input = overlay.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 40);
    }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); setSearch(true); }
    if (e.target.closest('[data-search-close]')) { setSearch(false); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setSearch(false); setDrawer(false); }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + parseInt(btn.getAttribute('data-qty'), 10);
    input.value = next < min ? min : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Collection sort ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Variant selection ---------- */
  var formRoot = document.querySelector('[data-product-form]');
  if (formRoot) {
    var dataEl = formRoot.querySelector('[data-variant-data]');
    var displayEl = formRoot.querySelector('[data-variant-display]');
    var variants = [];
    var display = {};
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }
    try { display = JSON.parse(displayEl.textContent); } catch (err) { display = {}; }

    var idInput = formRoot.querySelector('[data-variant-id]');
    var addButton = formRoot.querySelector('[data-add-button]');
    var priceEl = document.querySelector('[data-price] .amount');
    var skuEl = document.querySelector('[data-sku]');

    function selectedOptions() {
      var checked = formRoot.querySelectorAll('input[type="radio"]:checked');
      var values = [];
      checked.forEach(function (input) {
        var i = parseInt(input.getAttribute('data-option-index'), 10) - 1;
        values[i] = input.value;
      });
      return values;
    }

    function matchVariant(values) {
      if (!values.length) return variants[0];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opts = v.options || [v.option1, v.option2, v.option3];
        var ok = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] !== undefined && opts[j] !== values[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function update() {
      var values = selectedOptions();
      var variant = matchVariant(values);

      formRoot.querySelectorAll('[data-option-display]').forEach(function (el) {
        var i = parseInt(el.getAttribute('data-option-display'), 10) - 1;
        if (values[i]) el.textContent = values[i];
      });

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = addButton.getAttribute('data-unavailable') || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      var info = display[variant.id] || {};
      if (priceEl && info.price) {
        priceEl.innerHTML = (info.compare ? '<s>' + info.compare + '</s> ' : '') + info.price;
      }
      if (skuEl && typeof info.sku === 'string') skuEl.textContent = info.sku;

      if (addButton) {
        var available = info.available !== undefined ? info.available : variant.available;
        addButton.disabled = !available;
        addButton.textContent = available
          ? (addButton.getAttribute('data-add') || 'Add to bag')
          : (addButton.getAttribute('data-soldout') || 'Sold out');
      }

      if (window.history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    formRoot.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) update();
    });
  }

  /* ---------- Quick add (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.card__quick-form');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('button');
    var original = button ? button.textContent : '';
    if (button) button.textContent = '…';

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        if (button) button.textContent = 'Added';
        setTimeout(function () { if (button) button.textContent = original; }, 1600);
      })
      .catch(function () {
        if (button) button.textContent = original;
        form.submit();
      });
  });
})();
